var React = require('react');
var ReactNative = require('react-native');
var NativeAppEventEmitter = require('./wrappers/NativeAppEventEmitter-wrapper');

var Animated = require('./wrappers/Animated')

var {
  AppRegistry,
  Text,
  View,
  Image,
  ScrollView,
  DeviceEventEmitter,
  Platform,
  NativeModules,
  StyleSheet,
} = ReactNative;

var Icon = require('./wrappers/ReUpIcon');
var Svg = require('./wrappers/react-native-svg-wrapper');
var {
    Path,
    G,
    Circle
} = Svg;
var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKColor,
  MKCardStyles,
  MKTextField,
  MKButton
} = MK;

var PlatformConstants = require('./constants/PlatformConstants');
var RNPayPalManager = NativeModules.RNPayPalManager;
var MKSegmentControl = require('./MKSegmentControl.js');
var ReUpButton = require('./ReUpButton.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ReUpText = require('./ReUpText');

var PRICE_BUTTON_WIDTH = 120;

function cardTypeForNumber(cardNumber)
{
  if (cardNumber.length < 2) return -1;

  var range = parseInt(cardNumber.substring(0, 2));

  if (range >= 40 && range <= 49) {
      return 1;//PKCardTypeVisa;
  } else if (range >= 50 && range <= 59) {
      return 2;//PKCardTypeMasterCard;
  } else if (range == 34 || range == 37) {
      return 3;//PKCardTypeAmex;
  } else if (range == 60 || range == 62 || range == 64 || range == 65) {
      return 4;//PKCardTypeDiscover;
  } else if (range == 35) {
      return 5;//PKCardTypeJCB;
  } else if (range == 30 || range == 36 || range == 38 || range == 39) {
      return 6;//PKCardTypeDinersClub;
  } else {
    return -1;
  }
}

function cardNumberIsValidLength(cardNumber)
{
  var cardType = cardTypeForNumber(cardNumber);

  return cardNumber.length >= validLengthForCardType(cardType);
}

function validLengthForCardType(cardType)
{
  if( cardType == 3 ) // amex
  {
    return 15;
  }
  else
  {
    return 16;
  }
}

function iconNameForCardType(cardType)
{
  if (cardType == 1) {
      return "cc-visa";//PKCardTypeVisa;
  } else if (cardType == 2) {
      return "cc-mastercard";//PKCardTypeMasterCard;
  } else if (cardType == 3) {
      return "cc-amex";//PKCardTypeAmex;
  } else if (cardType == 4) {
      return "cc-discover";//PKCardTypeDiscover;
  } else if (cardType == 5) {
      return "cc-jcb";//PKCardTypeJCB;
  } else if (cardType == 6) {
      return "cc-diners-club";//PKCardTypeDinersClub;
  } else {
    return "credit-card";
  }
}

var PaymentMethodChooserView = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      appManager : null,
      appActions : null,
      paymentInfo : [],
      enableEdit : true,
      useSmall : false,
    }
  },

  getInitialState : function()
  {
    return this.props;
  },

  _didRetriveClientMetadataIDListener : null,
  _clientMetadataID : null,
  componentDidMount : function()
  {
    if( RNPayPalManager ) RNPayPalManager.retrieveClientMetadataID();
    var thisThing = this;
    if( Platform.OS == 'ios' )
    {
      this._didRetriveClientMetadataIDListener = NativeAppEventEmitter.addListener(
        'didRetriveClientMetadataID',
        (evt) =>
        {
          thisThing._clientMetadataID = evt.clientMetadataID;
        });
    }
    else
    {
      if( DeviceEventEmitter )
      {
        this._didRetriveClientMetadataIDListener = DeviceEventEmitter.addListener(
          'didRetriveClientMetadataID',
          (evt) =>
          {
            thisThing._clientMetadataID = evt.clientMetadataID;
          });
      }
    }
  },

  componentWillUnmount : function()
  {
    if( this._didRetriveClientMetadataIDListener != null ) this._didRetriveClientMetadataIDListener.remove();
  },

  componentWillReceiveProps : function(newProps)
  {
    // RNPayPalManager.retrieveClientMetadataID();
    this.setState(newProps)
  },

  getPrimaryPaymentMethod : function()
  {
    if( this.state.paymentInfo.length <= 0 ) return null;

    for( var i = 0; i < this.state.paymentInfo.length; i++ )
    {
      var info = this.state.paymentInfo[i];
      if( info.isPrimary )
      {
        if( this.methodIsPayPal(info) ) info.clientMetadataID = this.getClientMetadataID();
        return info;
      }
    }

    return null;
  },

  methodIsPayPal : function(method)
  {
    return method != null && typeof method.sourceType !== 'undefined' && method.sourceType == 'pp';
  },

  getClientMetadataID : function()
  {
    return this._clientMetadataID;
  },

  render : function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var locManager = this.props.appManager.getLocalizationManager();
    var appActions = this.props.appActions;

    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
    var bodyColor = appManager.getColorForKey("FeedCardBodyColor");
    var primaryButtonColor = appManager.getColorForKey("ButtonPrimaryColor");
    var primaryButtonTitleColor = appManager.getColorForKey("ButtonPrimaryTitleColor");
    var primaryButtonBorderColor = appManager.getColorForKey("ButtonPrimaryBorderColor");
    var secondaryButtonColor = appManager.getColorForKey("ButtonSecondaryColor");
    var secondaryButtonTitleColor = appManager.getColorForKey("ButtonSecondaryTitleColor");
    var secondaryButtonBorderColor = appManager.getColorForKey("ButtonSecondaryBorderColor");

    var currentMethod = this.getPrimaryPaymentMethod();
    var isPayPal = this.methodIsPayPal(currentMethod);

    if( this.props.useSmall )
    {
      var cardText = null;
      if( currentMethod != null ) cardText = "**** **** **** " + currentMethod.last4;

      return (
        <View style={{alignSelf:'stretch',flex:1, justifyContent:'center'}}>
        {
          isPayPal ?
          <MKButton disabled={!this.props.enableEdit} onPress={() => { appActions.requestFeatureName("PaymentTypes", {shouldPopAfterSelectingPaymentType:true}); }}
            style={{height:50,flex:1, flexDirection:'row', alignItems:'center'}}>
            <Image resizeMode={Image.resizeMode.contain} source={{uri:PlatformConstants.packagedResourcesDirectory + '/App/paypal.png'}} style={{backgroundColor:'transparent', height:40, width:120}} />
            <View style={{flex:1, alignSelf:'center'}}>
              <ReUpText disabled={!this.props.enableEdit} appManager={appManager} style={{
                margin:4,
                textAlign:'center',
                opacity:.6,
              }} numberOfLines={1}>{currentMethod.username}</ReUpText>
            </View>
          </MKButton>
          :
          currentMethod != null ?
          <MKButton disabled={!this.props.enableEdit} onPress={() => { appActions.requestFeatureName("PaymentTypes", {shouldPopAfterSelectingPaymentType:true}); }}
            style={{height:50,flex:1, flexDirection:'row', alignItems:'center', justifyContent:'center'}}>
              <Icon style={styles.creditCardIcon} name={iconNameForCardType(currentMethod.cardType)} size={26} color={generalTitleColor} />
              <View style={{flex:-1, flexDirection:'row'}}><ReUpText appManager={appManager} style={{
                  margin:4,
                  flex:-1,
                  textAlign:'center',
                  opacity:.8,
                }}>{currentMethod.last4}</ReUpText>
              </View>
          </MKButton>
          :
          <ReUpButton appManager={appManager} style={[styles.doneButton]} text={locManager.localizedStringForKey("SET_PAYMENT_TYPE_BUTTON")}
            onPress={()=>{appActions.requestFeatureName("PaymentTypes", {shouldPopAfterSelectingPaymentType:true});}} />
        }
        </View>
      )
    }

    var cardText = null;
    if( currentMethod != null ) cardText = "**** **** **** " + currentMethod.last4;

    var currentMethodProps = {};
    if( this.props.enableEdit ) currentMethodProps.icon = "pencil";

    return (
      <View key={currentMethod != null ? "0" : "1"} style={[styles.oldCardContainer, {backgroundColor:currentMethod != null ? generalColor : "transparent", borderRadius:4, paddingHorizontal:10, height:50}, this.props.style]}>
      {
        isPayPal ?
          <ReUpButton disabled={!this.props.enableEdit} appManager={appManager} isTertiary={true} iconColor={'black'} style={[{
            flex: 1,
            alignItems: 'stretch',
            borderRadius:2,
          }, {backgroundColor: 'transparent', paddingTop: 0}]}
            onPress={() => { appActions.requestFeatureName("PaymentTypes", {shouldPopAfterSelectingPaymentType:true}); }}
            text={currentMethod.username}
            {...currentMethodProps}>
            <View><Image resizeMode={Image.resizeMode.contain} source={{uri:PlatformConstants.packagedResourcesDirectory + '/App/paypal.png'}} style={{backgroundColor:'transparent', height:30, width:90}} /></View>
          </ReUpButton>
        :
        currentMethod != null ?
          <ReUpButton disabled={!this.props.enableEdit} appManager={appManager} isTertiary={true} iconColor={'black'} style={[{
            flex: 1,
            alignItems: 'stretch',
            borderRadius:2,
          }, {backgroundColor: 'transparent', paddingTop: 0}]}
            onPress={() => { appActions.requestFeatureName("PaymentTypes", {shouldPopAfterSelectingPaymentType:true}); }}
            text={cardText}
            {...currentMethodProps}>
            <View><Icon style={styles.creditCardIcon} name={iconNameForCardType(currentMethod.cardType)} size={26} color={generalTitleColor} /></View>
          </ReUpButton>
        :
          <ReUpButton appManager={appManager} style={[styles.doneButton]} text={locManager.localizedStringForKey("SET_PAYMENT_TYPE_BUTTON")}
            onPress={()=>{appActions.requestFeatureName("PaymentTypes", {shouldPopAfterSelectingPaymentType:true});}} />
      }
      </View>
    )
  }
})

var styles = StyleSheet.create({
oldCardContainer: {
  flexDirection:'row',
  // margin:10,
  alignItems:'center',
  justifyContent:'center',
},
creditCardIcon: {
  width: 50,
  justifyContent: 'center',
  textAlign: 'center',
  margin:4,
  opacity:.6,
},
creditCardText: {
  fontStyle:'italic',
  margin:4,
  flex:1,
  textAlign:'center',
  opacity:.6,
},
creditCardEditButton: {
  padding:4,
},
creditCardEditButtonIcon: {
  fontSize:30,
  backgroundColor:'transparent'
},
doneButton: {
  justifyContent:'center',
  flex:1,
  paddingHorizontal:10,
  // marginRight:10,
  // marginLeft:10,
},
})


module.exports = PaymentMethodChooserView;
